export default __webpack_public_path__ + "images/combo-chart-dummy-140.b95fd63dca705f1e5d86214cc3ed9544.svg";